import React from "react";
import { Box } from "@material-ui/core";
import { useStyles } from "../ThemeModal/styles/index.styles";
import { useModal } from "../../../hooks/useModal";
import CourseDetails from "../../../../courses/components/CourseDetails";

export function CourseDetailsModal() {
  const classes = useStyles();
  const { dataModal } = useModal();

  return (
    <Box className={classes.containerBody}>
      <CourseDetails courseId={dataModal?.data?.idCourse} />
    </Box>
  );
}
